<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-3 flex mt-2">
        <li>
          <router-link to="/setup/leave-management" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditLeave") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.UserName") }}
                  <span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.UserName')"
                >
                  <v-select
                    label="username"
                    v-model="userId"
                    :options="userList || []"
                    :reduce="(obj) => obj.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                    disabled
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.ShiftName") }}
                  <span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ShiftName')"
                >
                  <v-select
                    label="name"
                    v-model="sessionName"
                    :options="distinctSessions || []"
                    :reduce="(obj) => obj.name"
                    @input="onChangeSessionName"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                    disabled
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col sm:w-full lg:w-1/3 md:w-1/3">
              <vs-input
                :label="$t('setup.label.Status')"
                v-model="status"
                disabled
                class="w-full font-semibold mb-2 starlabel"
              />
            </div>
          </div>
          <div class="w-full">
            <h3 class="mb-2 font-semibold">
              {{ $t("setup.label.LeaveDetails") }}
            </h3>
            <div
              v-for="(entry, index) in leaveEntries"
              :key="index"
              class="vx-row mb-2 items-center"
            >
              <div class="vx-col md:w-1/4 sm:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("setup.label.StartDate") }}
                    <span class="required">*</span></small
                  >
                  <Datepicker
                    v-model="entry.startDate"
                    placeholder="Leave Start Date"
                    class="w-full"
                  />
                </div>
              </div>
              <div class="vx-col md:w-1/4 sm:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("setup.label.EndDate") }}
                    <span class="required">*</span></small
                  >
                  <Datepicker
                    v-model="entry.endDate"
                    placeholder="Leave End Date"
                    class="w-full"
                  />
                </div>
              </div>

              <div class="vx-col md:w-1/4 sm:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("setup.label.LeaveType") }}
                    <span class="required">*</span></small
                  >
                  <v-select
                    v-model="entry.leaveType"
                    :options="['Full day', 'Half day']"
                    placeholder="Select Leave Type"
                    class="w-full"
                  ></v-select>
                </div>
              </div>

              <div v-if="entry.leaveType == 'Half day'" class="vx-col md:w-1/4 sm:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("setup.label.Session") }}
                    <span class="required">*</span></small
                  >
                  <v-select
                    label="sessionType"
                    v-model="entry.session"
                    :options="sessionList || []"
                    placeholder="Select Session"
                    class="w-full"
                    :reduce="(obj) => obj.configId"
                    :disabled="entry.leaveType !== 'Half day'"
                  ></v-select>
                </div>
              </div>

              <!-- <div
                v-if="index !== 0"
                class="vx-col md:w-1/5 sm:w-full flex items-center"
              >
                <vs-button
                  color="danger"
                  type="filled"
                  size="small"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  @click="removeLeaveEntry(index)"
                  >{{ $t("setup.label.Remove") }}</vs-button
                >
              </div> -->
            </div>

            <!-- <div class="vx-row mt-4">
              <div class="vx-col w-full flex justify-center">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  color="primary"
                  type="filled"
                  @click="addLeaveEntry"
                >
                  {{ $t("setup.label.AddAnotherDate") }}
                </vs-button>
              </div>
            </div> -->
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="$router.push('/setup/leave-management')"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="updateUserAvailability"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import "flatpickr/dist/flatpickr.css";
import { mapState } from "vuex";
export default {
  data() {
    return {
      userId: "",
      sessionName: "",
      warningPopup: false,
      userList: [],
      sessionList: [],
      warningText: "",
      errorMessage: "",
      leaveEntries: [
        {
          startDate: null,
          endDate: null,
          leaveType: "",
          session: "",
        },
      ],
      status: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    Datepicker,
  },
  computed: {
    ...mapState({
      leaveByUserId: (state) => state.teams.leaveByUserId,
      shiftsList: (state) => state.shiftManagement.shiftsList,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    distinctSessions() {
      const seenNames = new Set();
      return this.shiftsList.filter((session) => {
        if (seenNames.has(session.name)) {
          return false;
        }
        seenNames.add(session.name);
        return true;
      });
    },
  },
  methods: {
    addLeaveEntry() {
      this.leaveEntries.push({
        startDate: null,
        endDate: null,
        leaveType: "",
        session: "",
      });
    },
    removeLeaveEntry(index) {
      this.leaveEntries.splice(index, 1);
    },
    onChangeSessionName(sessionName) {
      const matchedSessions = this.shiftsList.filter(
        (e) => e.name === sessionName
      );
      this.sessionList = matchedSessions;
    },
    async getUsersList() {
      try {
        const res = await this.$store.dispatch(
          "teamMapping/fetchCreateTemplate"
        );
        this.userList = res && res.data && res.data.appUserData;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateUserAvailability() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const availabilities = this.leaveEntries.flatMap((entry) => {
        const matchedSession = this.shiftsList.find(
          (shift) => shift.configId === entry.session
        );

        const sessionType = matchedSession ? matchedSession.sessionType : "";

        if (entry.leaveType === "Half day") {
          return [
            {
              id: Number(this.$route.params.id),
              userId: this.userId,
              configId: entry.session,
              recurrence: "weekly",
              sessionDate: moment(entry.startDate).format("YYYY-MM-DD"),
              sessionEndDate: moment(entry.endDate).format("YYYY-MM-DD"),
              sessionType: sessionType,
              isAvailable: false,
              status: "Leave",
              count: 1,
            },
          ];
        }

        if (entry.leaveType === "Full day") {
          const allSessionsForDay = this.shiftsList.filter(
            (e) => e.name === this.sessionName
          );
          return allSessionsForDay.map((shift) => ({
            id: Number(this.$route.params.id),
            userId: this.userId,
            configId: shift.configId,
            recurrence: "weekly",
            sessionDate: moment(entry.startDate).format("YYYY-MM-DD"),
            sessionEndDate: moment(entry.endDate).format("YYYY-MM-DD"),
            sessionType: shift.sessionType,
            isAvailable: false,
            status: "Leave",
            count: 1,
          }));
        }

        return [];
      });
      try {
        const payload = {
          id: this.$route.params.userId,
          data: {
            availabilities,
          },
        };
        await this.$store.dispatch(
          "teams/updateUserAvailabilityAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Leave Updated Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/leave-management`);
      } catch (e) {
        const errorMessage =
          e &&
          e.message &&
          e.message.defaultUserMessage &&
          e.message.defaultUserMessage.replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          text: errorMessage,
          type: "error",
        });
      }
    },
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    getTime(time) {
      return moment(time, "HH:mm:ss").format("HH:mm:ss");
    },
    async getLeaveByUserIdMethod() {
      try {
        await this.$store.dispatch(
          "teams/getLeaveByUserIdAction",
          this.$route.params.userId
        );

        const leaveData = this.leaveByUserId;
        if (!leaveData || leaveData.length === 0) return;

        this.userId = leaveData[0].userId;
        this.status = leaveData[0].status;

        const firstConfigId = leaveData[0].configId;
        const matchedShift = this.shiftsList.find(
          (shift) => shift.configId === firstConfigId
        );
        if (matchedShift) {
          this.sessionName = matchedShift.name;
          this.onChangeSessionName(this.sessionName);
        }

        const groupedLeaves = leaveData.reduce((map, entry) => {
          const key = moment(entry.sessionDate).format("YYYY-MM-DD");
          if (!map.has(key)) map.set(key, []);
          map.get(key).push(entry);
          return map;
        }, new Map());
        this.leaveEntries = Array.from(groupedLeaves.entries()).map(
          ([dateKey, entries]) => {
            const isFullDay = entries.length == this.sessionList.length;

            const startDate = entries[0].sessionDate
              ? new Date(entries[0].sessionDate)
              : new Date(dateKey);

            const endDate = entries[0].sessionEndDate
              ? new Date(entries[0].sessionEndDate)
              : new Date(dateKey);

            return {
              startDate,
              endDate,
              leaveType: isFullDay ? "Full day" : "Half day",
              session: isFullDay ? "" : entries[0].configId,
            };
          }
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getShiftsListMethod() {
      try {
        this.$store.dispatch("shiftManagement/getShiftsListAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancel() {
      this.$router.push(`/setup/leave-management`);
    },
  },
  watch: {},
  async mounted() {
    this.getUsersList();
    this.getShiftsListMethod();
    await this.getLeaveByUserIdMethod();
  },
};
</script>
